import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { objectiveGroupsWithObjectivesAndPointsSelector } from '../../slices/PatientSlice';
import * as Styled from './ObjectiveGroupsList.styled';
import ObjectiveGroup from './ObjectiveGroup/ObjectiveGroup';
import {
  overlaysSelector,
  toggleOverlay,
} from '../../slices/vh-player/VHPlayerSlice';
import { unmatchedResponseCountSelector } from '../../slices/chat/ChatSlice';
import {
  firstIncompleteObjectiveGroupWithUnusedHintSelector,
  groupIdHintIndicatorShownSelector,
  setGroupIdHintIndicatorShown,
  shownHintObjectiveIdsSelector,
} from '../../slices/ObjectivesSlice';
import { usePrevious } from '../../../../../utility/CustomHooks';

const ObjectiveGroupsList = () => {
  const objectiveGroupsWithObjectivesAndPoints = useSelector(
    objectiveGroupsWithObjectivesAndPointsSelector
  );
  const overlays = useSelector(overlaysSelector);
  const overlayState = overlays.objectives;
  const dispatch = useDispatch();

  const shownHintObjectiveIds = useSelector(shownHintObjectiveIdsSelector);
  const unmatchedResponseCount = useSelector(unmatchedResponseCountSelector);
  const firstIncompleteObjectiveGroupWithUnusedHint = useSelector(
    firstIncompleteObjectiveGroupWithUnusedHintSelector
  );

  // dispatch to show hint indicator popover for first group if there is a hint and no hint indicator has been shown yet
  useEffect(() => {
    if (
      firstIncompleteObjectiveGroupWithUnusedHint?.id &&
      unmatchedResponseCount >= 2 &&
      shownHintObjectiveIds.length === 0
    ) {
      dispatch(
        setGroupIdHintIndicatorShown(
          firstIncompleteObjectiveGroupWithUnusedHint.id
        )
      );
    }
  }, [
    dispatch,
    unmatchedResponseCount,
    firstIncompleteObjectiveGroupWithUnusedHint?.id,
    shownHintObjectiveIds.length,
  ]);

  // we want to make sure the objectives area is open when the "use a hint" popover shows up
  const groupIdHintIndicatorBeenShown = useSelector(
    groupIdHintIndicatorShownSelector
  );
  const prevGroupIdHintIndicatorBeenShown = usePrevious(
    groupIdHintIndicatorBeenShown
  );

  useEffect(() => {
    if (
      !prevGroupIdHintIndicatorBeenShown &&
      groupIdHintIndicatorBeenShown &&
      !overlayState.visible
    ) {
      dispatch(toggleOverlay('objectives'));
    }
  }, [
    groupIdHintIndicatorBeenShown,
    prevGroupIdHintIndicatorBeenShown,
    dispatch,
    overlayState,
  ]);

  return (
    <Styled.ObjectiveGroupsListWrapper>
      <Styled.ObjectiveGroupsList>
        {objectiveGroupsWithObjectivesAndPoints.map((objectiveGroup) => (
          <ObjectiveGroup
            key={objectiveGroup.id}
            objectiveGroup={objectiveGroup}
          />
        ))}
      </Styled.ObjectiveGroupsList>
    </Styled.ObjectiveGroupsListWrapper>
  );
};

export default ObjectiveGroupsList;
